// RequestPendingIcon

import React from "react";

const RequestPendingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      opacity="0.21"
      d="M37 0C49.7025 0 60 10.2975 60 23V37C60 49.7025 49.7025 60 37 60H23C10.2975 60 0 49.7025 0 37V23C0 10.2975 10.2975 0 23 0H37Z"
      fill="#FEDD2B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 24.3164L27.9005 31.7645C28.0394 31.8447 28.1851 31.9026 28.3333 31.9394V46.3846L15.9201 39.0385C15.3498 38.701 15 38.0875 15 37.4248V24.3164ZM45 24.1184V37.4248C45 38.0875 44.6502 38.701 44.0799 39.0385L31.6667 46.3846V31.8129C31.6969 31.7978 31.7269 31.7816 31.7566 31.7645L45 24.1184Z"
      fill="#FEDD2B"
    />
    <path
      opacity="0.499209"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4043 20.7014C15.5619 20.5024 15.7608 20.3343 15.9926 20.2108L29.1176 13.2201C29.6686 12.9266 30.3295 12.9266 30.8805 13.2201L44.0055 20.2108C44.1843 20.306 44.3434 20.4277 44.4791 20.5697L30.089 28.8778C29.9943 28.9325 29.9071 28.995 29.8276 29.064C29.7481 28.995 29.6609 28.9325 29.5662 28.8778L15.4043 20.7014Z"
      fill="#FEDD2B"
    />
  </svg>
);

export default RequestPendingIcon;
